export default __webpack_public_path__ + "static/eniyan_1_1_en-3db2a5a076fe51134f1660d0bc90cf41.jpg";